import { DatePipe, NgComponentOutlet } from '@angular/common';
import { Component, ElementRef, Injector, OnInit, ViewChild, computed, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatTooltip } from '@angular/material/tooltip';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { EMPTY } from 'rxjs';

import { ModalCadastroLembreteComponent } from '../../../lembrete/modal-cadastro-lembrete/modal-cadastro-lembrete.component';
import { CampoSelectComponent } from '../../../shared/components/redesign/campo-select/campo-select.component';
import { ModalConfirmacaoComponent } from '../../../shared/components/redesign/modal-confirmacao/modal-confirmacao.component';
import { ModalEditarContatoComponent } from '../../../shared/components/redesign/modal-editar-contato/modal-editar-contato.component';
import { Contato } from '../../../shared/model/contato/contato.model';
import { IdNome } from '../../../shared/model/id-nome.model';
import { Lembrete } from '../../../shared/model/lembrete/lembrete.model';
import { SessaoBuscaContato } from '../../../shared/model/sessao/sessao-busca-contato.model';
import { Sessao } from '../../../shared/model/sessao/sessao.model';
import { CelularMaskPipe } from '../../../shared/pipe/celular-mask.pipe';
import { CanalService } from '../../../shared/service/canal.service';
import { ContatoService } from '../../../shared/service/contato.service';
import { EtapaService } from '../../../shared/service/etapa-service';
import { FluxoService } from '../../../shared/service/fluxo-service';
import { LembreteService } from '../../../shared/service/lembrete.service';
import { MsgService } from '../../../shared/service/msg.service';
import { RestricaoService } from '../../../shared/service/restricao.service';
import { SessaoService } from '../../../shared/service/sessao.service';
import { UsuarioService } from '../../../shared/service/usuario.service';
import { MethodsUtils } from '../../../shared/util/methods.utils';
import { ValidacaoAlteracaoCampoService } from '../../../shared/service/utilitarios/validacao-alteracao-campo.service';
import { animacaoDeslizar, animacaoExpandir, animacaoSurgirHistorico } from '../../utils/chat-animacoes.utils';
import { ArrastarAbasDirective } from '../../utils/arrastar-abas.directive';
import { ChatAcoesContatoService } from '../../../shared/service/chat-acoes-contato.service';
import { AbaPerfil } from './models/aba-perfil.model';
import { PerfilContatoChatData } from './models/perfil-contato-chat-data.model';
import { PerfilContatoChatResultado } from './models/perfil-contato-chat-resultado.model';
import { SobreposicaoPerfil } from './models/sobreposicao-perfil.model';
import { AlvoLocalizacaoChat } from '../models/alvo-localizacao-chat.model';
import { EventoHistorico } from './models/evento-historico.model';
import { SessaoHistorico } from './models/sessao-historico.model';
import {
  LIMIAR_PRE_CARGA_CARROSSEL, ORDEM_ABAS_PERFIL, TAMANHO_PAGINA_HISTORICO, TAMANHO_PAGINA_LEMBRETES, TAMANHO_PAGINA_LEMBRETES_HOJE
} from './utils/perfil-contato-chat.constantes';
import { LembreteContagem } from '../../../shared/model/lembrete/lembrete-contagem.model';
import { PageModel } from '../../../shared/model/page-mode.model';
import { AvatarPessoaComponent } from '../../../shared/components/redesign/avatar-pessoa/avatar-pessoa.component';
import { ArrastarFecharSheetDirective } from '../../utils/arrastar-fechar-sheet.directive';
import { CardLembreteContatoComponent } from './card-lembrete-contato/card-lembrete-contato.component';
import { FiltroLembretesContato } from './models/filtro-lembretes-contato.model';
import { CarrosselComponent } from '../../../shared/components/redesign/carrossel/carrossel.component';

@Component({
  selector: 'app-perfil-contato-chat',
  standalone: true,
  imports: [DatePipe, FormsModule, NgComponentOutlet, CampoSelectComponent, CelularMaskPipe, ArrastarAbasDirective, ArrastarFecharSheetDirective,
    AvatarPessoaComponent, MatTooltip, CardLembreteContatoComponent, CarrosselComponent],
  templateUrl: './perfil-contato-chat.component.html',
  styleUrl: './perfil-contato-chat.component.css',
  animations: [animacaoDeslizar, animacaoExpandir, animacaoSurgirHistorico]
})
export class PerfilContatoChatComponent implements OnInit {
  private readonly data = inject<PerfilContatoChatData>(MAT_DIALOG_DATA);
  private readonly dialogRef = inject<MatDialogRef<PerfilContatoChatComponent, PerfilContatoChatResultado>>(MatDialogRef);
  private readonly dialog = inject(MatDialog);
  private readonly contatoService = inject(ContatoService);
  private readonly restricaoService = inject(RestricaoService);
  private readonly lembreteService = inject(LembreteService);
  private readonly sessaoService = inject(SessaoService);
  private readonly canalService = inject(CanalService);
  private readonly usuarioService = inject(UsuarioService);
  private readonly fluxoService = inject(FluxoService);
  private readonly etapaService = inject(EtapaService);
  private readonly acoesContatoService = inject(ChatAcoesContatoService);
  private readonly msgService = inject(MsgService);
  private readonly alteracaoService = inject(ValidacaoAlteracaoCampoService);
  private readonly injector = inject(Injector);

  @ViewChild('conteudo') conteudo?: ElementRef<HTMLElement>;
  @ViewChild(ArrastarAbasDirective) arrastarAbas?: ArrastarAbasDirective;

  protected readonly componenteLembrete = ModalCadastroLembreteComponent;
  protected injetorLembrete?: Injector;

  readonly contato: Contato = this.data.contato;
  readonly mostraEncerraAtendimento = this.data.mostraEncerraAtendimento;

  aba = signal<AbaPerfil>('detalhes');
  sobreposicao = signal<SobreposicaoPerfil | null>(null);
  carregando = signal(true);
  sessaoAtual = signal<SessaoBuscaContato | null>(null);
  ocultarNumero = signal(false);
  carregandoLembrete = signal(true);
  lembretesHoje = signal<Lembrete[]>([]);
  totalLembretesHoje = signal(0);
  indiceLembrete = signal(0);
  private paginaLembretesHoje = -1;
  private temMaisLembretesHoje = true;
  private buscandoLembretesHoje = false;
  private versaoLembretesHoje = 0;

  lembretesContato = signal<Lembrete[]>([]);
  carregandoLembretesContato = signal(false);
  filtroLembretes = signal<FiltroLembretesContato>('pendentes');
  lembretesMaisRecentes = signal(true);
  contagemLembretes = signal<LembreteContagem | null>(null);
  private paginaLembretesContato = -1;
  private temMaisLembretesContato = true;
  private versaoLembretesContato = 0;
  readonly qtdLembretesConcluidos = computed(() => this.contagemLembretes()?.concluidos ?? 0);
  readonly qtdLembretesPendentes = computed(() => (this.contagemLembretes()?.todos ?? 0) - this.qtdLembretesConcluidos());

  historico = signal<SessaoBuscaContato[]>([]);
  carregandoHistorico = signal(false);
  sessaoAberta = signal<number | null>(null);
  readonly linhaDoTempo = computed<SessaoHistorico[]>(() => this.historico().map(sessao => this.montarSessaoHistorico(sessao)));
  private paginaHistorico = -1;
  private temMaisHistorico = true;

  readonly sessaoAtiva = computed(() => !!this.sessaoAtual()?.ativo);

  canais = signal<IdNome[]>([]);
  operadores = signal<IdNome[]>([]);
  fluxos = signal<IdNome[]>([]);
  etapas = signal<any[]>([]);
  carregandoCanais = signal(false);
  carregandoOperadores = signal(false);
  carregandoFluxos = signal(false);
  carregandoEtapas = signal(false);
  transferindo = signal(false);
  canalSelecionado: IdNome | null = null;
  operadorSelecionado: IdNome | null = null;
  fluxoSelecionado: any = null;
  etapaSelecionada: any = null;
  private resultado: PerfilContatoChatResultado = {};

  ngOnInit(): void {
    this.dialogRef.disableClose = true;
    this.dialogRef.backdropClick().subscribe(() => this.fechar());
    this.dialogRef.keydownEvents().subscribe(evento => {
      if (evento.key !== 'Escape') return;
      if (this.sobreposicao() === 'transferir') this.voltarParaPerfil();
      else if (!this.sobreposicao()) this.fechar();
    });

    this.sessaoService.buscarSessaoAtualContato(this.contato.id).subscribe({
      next: sessao => {
        this.sessaoAtual.set(sessao ?? null);
        this.carregando.set(false);
        if (this.data.visaoInicial === 'transferir') this.abrirTransferencia();
      },
      error: () => {
        this.carregando.set(false);
        this.msgService.msgErro('Não foi possível carregar o atendimento do contato.');
      }
    });
    this.restricaoService.buscarOcultarNumeroCelular().subscribe(ocultar => this.ocultarNumero.set(ocultar));
    this.reiniciarLembretesHoje();
  }

  selecionarAba(aba: AbaPerfil): void {
    this.aba.set(aba);
    if (aba === 'historico' && this.paginaHistorico < 0) this.buscarMaisHistorico();
    if (aba === 'lembretes' && this.paginaLembretesContato < 0) this.reiniciarLembretesContato();
  }

  abaVizinha(passo: number): void {
    const indice = ORDEM_ABAS_PERFIL.indexOf(this.aba()) + passo;
    if (indice >= 0 && indice < ORDEM_ABAS_PERFIL.length) this.selecionarAba(ORDEM_ABAS_PERFIL[indice]);
  }

  clicarAba(aba: AbaPerfil): void {
    const sentido = Math.sign(ORDEM_ABAS_PERFIL.indexOf(aba) - ORDEM_ABAS_PERFIL.indexOf(this.aba()));
    if (!sentido) return;
    this.selecionarAba(aba);
    this.arrastarAbas?.animarEntrada(sentido);
  }

  filtrarLembretes(filtro: FiltroLembretesContato): void {
    if (filtro === this.filtroLembretes()) return;
    this.filtroLembretes.set(filtro);
    this.reiniciarLembretesContato();
  }

  alternarOrdenacaoLembretes(): void {
    this.lembretesMaisRecentes.set(!this.lembretesMaisRecentes());
    this.reiniciarLembretesContato();
  }

  aoMudarLembreteHoje(indice: number): void {
    this.indiceLembrete.set(indice);
    if (indice >= this.lembretesHoje().length - 1 - LIMIAR_PRE_CARGA_CARROSSEL) this.buscarMaisLembretesHoje();
  }

  private reiniciarLembretesHoje(): void {
    this.versaoLembretesHoje++;
    this.paginaLembretesHoje = -1;
    this.temMaisLembretesHoje = true;
    this.buscandoLembretesHoje = false;
    this.indiceLembrete.set(0);
    this.carregandoLembrete.set(true);
    this.buscarMaisLembretesHoje();
  }

  private buscarMaisLembretesHoje(): void {
    if (this.buscandoLembretesHoje || !this.temMaisLembretesHoje) return;
    this.buscandoLembretesHoje = true;
    const versao = this.versaoLembretesHoje;
    const pagina = this.paginaLembretesHoje + 1;
    this.lembreteService.buscarHojeContato(this.contato.id, pagina, TAMANHO_PAGINA_LEMBRETES_HOJE).subscribe({
      next: res => {
        if (versao !== this.versaoLembretesHoje) return;
        const novos: Lembrete[] = res?.content ?? [];
        this.lembretesHoje.set(pagina === 0 ? novos : [...this.lembretesHoje(), ...novos]);
        this.totalLembretesHoje.set(res?.totalElements ?? this.lembretesHoje().length);
        this.paginaLembretesHoje = pagina;
        this.temMaisLembretesHoje = this.temProximaPagina(res, pagina);
        this.buscandoLembretesHoje = false;
        if (pagina === 0) {
          this.carregandoLembrete.set(false);
          this.destacarLembreteSePedido();
        }
      },
      error: () => {
        if (versao !== this.versaoLembretesHoje) return;
        this.temMaisLembretesHoje = false;
        this.buscandoLembretesHoje = false;
        if (pagina === 0) {
          this.lembretesHoje.set([]);
          this.totalLembretesHoje.set(0);
          this.carregandoLembrete.set(false);
          this.destacarLembreteSePedido();
        }
      }
    });
  }

  private reiniciarLembretesContato(): void {
    this.versaoLembretesContato++;
    this.paginaLembretesContato = -1;
    this.temMaisLembretesContato = true;
    this.lembretesContato.set([]);
    this.carregandoLembretesContato.set(false);
    this.buscarMaisLembretesContato();
    this.lembreteService.contarPorStatusContato(this.contato.id).subscribe({
      next: contagem => this.contagemLembretes.set(contagem ?? null),
      error: () => this.contagemLembretes.set(null)
    });
  }

  private buscarMaisLembretesContato(): void {
    if (this.carregandoLembretesContato() || !this.temMaisLembretesContato) return;
    this.carregandoLembretesContato.set(true);
    const versao = this.versaoLembretesContato;
    const pagina = this.paginaLembretesContato + 1;
    this.lembreteService.buscarTodosContato(this.contato.id, this.filtroLembretes() === 'concluidos', !this.lembretesMaisRecentes(),
      pagina, TAMANHO_PAGINA_LEMBRETES).subscribe({
      next: res => {
        if (versao !== this.versaoLembretesContato) return;
        this.lembretesContato.set([...this.lembretesContato(), ...(res?.content ?? [])]);
        this.paginaLembretesContato = pagina;
        this.temMaisLembretesContato = this.temProximaPagina(res, pagina);
        this.carregandoLembretesContato.set(false);
        setTimeout(() => this.verificarPreCarga(), 0);
      },
      error: () => {
        if (versao !== this.versaoLembretesContato) return;
        this.temMaisLembretesContato = false;
        this.carregandoLembretesContato.set(false);
        this.msgService.msgErro('Não foi possível carregar os lembretes do contato.');
      }
    });
  }

  private temProximaPagina(res: PageModel | null, pagina: number): boolean {
    return res ? (res.number ?? pagina) + 1 < (res.totalPages ?? 0) : false;
  }

  aoRolarConteudo(): void {
    this.verificarPreCarga();
  }

  private verificarPreCarga(): void {
    const el = this.conteudo?.nativeElement;
    if (!el || el.scrollHeight - el.scrollTop - el.clientHeight >= el.clientHeight * 3) return;
    if (this.aba() === 'historico') this.buscarMaisHistorico();
    else if (this.aba() === 'lembretes') this.buscarMaisLembretesContato();
  }

  private buscarMaisHistorico(): void {
    if (this.carregandoHistorico() || !this.temMaisHistorico) return;
    this.carregandoHistorico.set(true);
    const pagina = this.paginaHistorico + 1;
    this.sessaoService.buscarHistoricoContato(this.contato.id, pagina, TAMANHO_PAGINA_HISTORICO).subscribe({
      next: res => {
        const novas: SessaoBuscaContato[] = res?.content ?? [];
        this.historico.set([...this.historico(), ...novas]);
        this.paginaHistorico = pagina;
        this.temMaisHistorico = this.temProximaPagina(res, pagina);
        this.carregandoHistorico.set(false);
        setTimeout(() => this.verificarPreCarga(), 0);
      },
      error: () => {
        this.temMaisHistorico = false;
        this.carregandoHistorico.set(false);
      }
    });
  }

  alternarSessao(sessaoId?: number): void {
    if (sessaoId == null) return;
    this.sessaoAberta.set(this.sessaoAberta() === sessaoId ? null : sessaoId);
  }

  localizarNoChat(alvo: AlvoLocalizacaoChat): void {
    if (!alvo.data && alvo.atendimentoId == null) return;
    this.dialogRef.close({ ...this.resultado, localizarNoChat: alvo });
  }

  private montarSessaoHistorico(sessao: SessaoBuscaContato): SessaoHistorico {
    const eventos: EventoHistorico[] = [];
    if (sessao.dataAbertura) {
      eventos.push({
        chave: `sessao-${sessao.id}-abertura`, tipo: 'sessao-aberta', data: new Date(sessao.dataAbertura).getTime(),
        titulo: 'Sessão iniciada', descricao: [sessao.canal?.nome, sessao.fluxo?.nome].filter(Boolean).join(' · ') || undefined,
        alvo: { data: sessao.dataAbertura }
      });
    }
    for (const atendimento of sessao.atendimentos ?? []) {
      if (atendimento.dataCriacao) {
        eventos.push({
          chave: `at-${atendimento.id}-inicio`, tipo: 'atendimento-inicio', data: new Date(atendimento.dataCriacao).getTime(),
          titulo: `Atendimento #${atendimento.id} iniciado`, pessoa: atendimento.operador,
          descricao: atendimento.operador?.nome ? undefined : 'Sem operador (chatbot)',
          alvo: { atendimentoId: atendimento.id, abertura: true, data: atendimento.dataCriacao }
        });
      }
      if (atendimento.dataFim) {
        eventos.push({
          chave: `at-${atendimento.id}-fim`, tipo: 'atendimento-fim', data: new Date(atendimento.dataFim).getTime(),
          titulo: `Atendimento #${atendimento.id} encerrado`,
          descricao: atendimento.dataCriacao
            ? `Duração: ${MethodsUtils.formatarDuracao(new Date(atendimento.dataFim).getTime() - new Date(atendimento.dataCriacao).getTime())}`
            : undefined,
          alvo: { atendimentoId: atendimento.id, abertura: false, data: atendimento.dataFim }
        });
      }
    }
    for (const log of sessao.logs ?? []) {
      if (!log.data) continue;
      eventos.push({
        chave: `log-${log.id}`, tipo: 'registro', data: new Date(log.data).getTime(), titulo: MethodsUtils.rotuloLogAtendimento(log),
        descricao: log.observacao || undefined, pessoa: log.autor, alvo: { data: log.data }
      });
    }
    if (!sessao.ativo && sessao.ultimaInteracao) {
      eventos.push({
        chave: `sessao-${sessao.id}-ultima`, tipo: 'sessao-ultima', data: new Date(sessao.ultimaInteracao).getTime(),
        titulo: 'Última interação', alvo: { data: sessao.ultimaInteracao }
      });
    }
    eventos.sort((a, b) => a.data - b.data);

    const inicio = sessao.dataAbertura ? new Date(sessao.dataAbertura).getTime() : null;
    const fim = sessao.ativo ? Date.now() : (sessao.ultimaInteracao ? new Date(sessao.ultimaInteracao).getTime() : null);
    return {
      sessao,
      eventos,
      qtdAtendimentos: sessao.atendimentos?.length ?? 0,
      duracao: inicio != null && fim != null ? MethodsUtils.formatarDuracao(fim - inicio) : '-'
    };
  }

  get fotoContato(): string {
    return MethodsUtils.fotoPerfilContato(this.contato.fotoPerfilUrl, this.contato.statusContato);
  }

  get possuiFotoPerfil(): boolean {
    return MethodsUtils.fotoPerfilDisponivel(this.contato.fotoPerfilUrl);
  }

  marcarFotoIndisponivel(): void {
    MethodsUtils.marcarFotoPerfilIndisponivel(this.contato.fotoPerfilUrl);
  }

  get email(): string {
    return this.contato.email ?? '';
  }

  get statusAtendimento(): { texto: string; classe: string } {
    const sessao = this.sessaoAtual();
    if (sessao?.ativo && (sessao.operador?.id || this.contato.operador?.id)) return { texto: 'Atendimento ativo', classe: 'ativo' };
    if (sessao?.ativo) return { texto: 'Sessão ativa', classe: 'sessao' };
    return { texto: 'Sem atendimento ativo', classe: 'inativo' };
  }

  rotuloIdNome(item?: IdNome | null): string {
    if (!item?.id) return '-';
    return `${item.id} - ${item.nome ?? ''}`;
  }

  numeroRecepcao(sessao?: SessaoBuscaContato): string {
    const conta = sessao?.conta;
    if (!conta?.id) return '-';
    return [conta.nome, conta.numero].filter(Boolean).join(' | ');
  }

  corPrazo(progresso?: number): string {
    return MethodsUtils.getCorPrazo(progresso ?? 0);
  }

  larguraPrazo(progresso?: number): number {
    return Math.max(4, Math.min(100, progresso ?? 0));
  }

  fechar(): void {
    if (this.sobreposicao() === 'lembrete') this.alteracaoService.camposNaoAlterados();
    this.dialogRef.close(this.resultado);
  }

  alternarFavorito(): void {
    const novoValor = !this.contato.favorito;
    this.contato.favorito = novoValor;
    this.contatoService.alterarFavorito(this.contato.id, novoValor).subscribe({
      error: () => {
        this.contato.favorito = !novoValor;
        this.msgService.msgErro('Não foi possível atualizar o contato como importante.');
      }
    });
  }

  editarContato(): void {
    this.dialog.open(ModalEditarContatoComponent, {
      data: { contatoId: this.contato.id, nome: this.contato.nome },
      panelClass: 'border-radius-7'
    }).afterClosed().subscribe((nome?: string) => {
      if (nome) this.contato.nome = nome;
    });
  }

  encerrarAtendimento(): void {
    this.acoesContatoService.encerrarAtendimento(this.contato.id, this.contato.nome).subscribe(encerrou => {
      if (encerrou) this.dialogRef.close({ ...this.resultado, encerrouAtendimento: true });
    });
  }

  encerrarSessao(): void {
    const sessao = this.sessaoAtual();
    if (!sessao?.id || !sessao.ativo) {
      this.msgService.msgAdvertencia('Sessão não se encontra mais ativa.');
      return;
    }
    this.acoesContatoService.encerrarSessao(sessao.id, this.contato.nome).subscribe({
      next: encerrou => {
        if (encerrou) this.dialogRef.close({ ...this.resultado, encerrouSessao: true });
      },
      error: () => this.msgService.msgErro('Não foi possível encerrar a sessão.')
    });
  }

  criarLembrete(): void {
    const refPainel = {
      close: (criou?: boolean) => this.aoFecharLembrete(!!criou),
      backdropClick: () => EMPTY,
      keydownEvents: () => EMPTY,
      afterClosed: () => EMPTY
    } as unknown as MatDialogRef<unknown>;
    this.injetorLembrete = Injector.create({
      parent: this.injector,
      providers: [
        { provide: MAT_DIALOG_DATA, useValue: { contato: this.contato } },
        { provide: MatDialogRef, useValue: refPainel }
      ]
    });
    this.sobreposicao.set('lembrete');
  }

  private aoFecharLembrete(criou: boolean): void {
    this.alteracaoService.camposNaoAlterados();
    this.sobreposicao.set(null);
    if (criou) {
      this.resultado.lembreteCriado = true;
      this.reiniciarLembretesHoje();
      if (this.paginaLembretesContato >= 0) this.reiniciarLembretesContato();
    }
  }

  lembreteEmFoco = signal(false);

  private destacarLembreteSePedido(): void {
    if (!this.data.focarLembrete || this.lembreteEmFoco()) return;
    this.data.focarLembrete = false;
    setTimeout(() => {
      this.lembreteEmFoco.set(true);
      this.conteudo?.nativeElement.querySelector('.perfil-lembrete, .perfil-acao-lembrete')
        ?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(() => this.lembreteEmFoco.set(false), 1200);
    }, 380);
  }

  abrirTransferencia(): void {
    const sessao = this.sessaoAtual();
    if (!sessao?.ativo) {
      this.msgService.msgAdvertencia('Sessão não se encontra mais ativa.');
      return;
    }
    this.canalSelecionado = sessao.canal?.id ? sessao.canal : null;
    this.operadorSelecionado = sessao.operador?.id ? { id: sessao.operador.id, nome: sessao.operador.nome } : null;
    this.fluxoSelecionado = sessao.fluxo?.id ? { id: sessao.fluxo.id, titulo: sessao.fluxo.nome } : null;
    this.etapaSelecionada = sessao.etapa?.id ? { id: sessao.etapa.id, titulo: sessao.etapa.nome } : null;
    this.sobreposicao.set('transferir');

    this.carregandoCanais.set(true);
    this.canalService.buscarCanaisAtivoDoGrupo().subscribe({
      next: canais => this.canais.set(canais ?? []),
      complete: () => this.carregandoCanais.set(false),
      error: () => this.carregandoCanais.set(false)
    });
    this.carregandoFluxos.set(true);
    this.fluxoService.buscar().subscribe({
      next: fluxos => this.fluxos.set(fluxos ?? []),
      complete: () => this.carregandoFluxos.set(false),
      error: () => this.carregandoFluxos.set(false)
    });
    if (this.canalSelecionado?.id) this.buscarOperadores(this.canalSelecionado.id);
    this.buscarEtapas(this.fluxoSelecionado?.id);
  }

  voltarParaPerfil(): void {
    this.sobreposicao.set(null);
  }

  selecionarCanal(canal: IdNome): void {
    const mudou = canal?.id !== this.canalSelecionado?.id;
    this.canalSelecionado = canal;
    if (!mudou) return;
    this.operadorSelecionado = null;
    if (canal?.id) {
      this.buscarOperadores(canal.id);
    } else {
      this.operadores.set([]);
    }
  }

  selecionarFluxo(fluxo: any): void {
    const mudou = fluxo?.id !== this.fluxoSelecionado?.id;
    this.fluxoSelecionado = fluxo;
    if (mudou) {
      this.etapaSelecionada = null;
      this.buscarEtapas(fluxo?.id);
    }
  }

  selecionarEtapa(etapa: any): void {
    this.etapaSelecionada = etapa;
    if (etapa?.canal?.id) this.selecionarCanal(etapa.canal);
  }

  private buscarOperadores(canalId: number): void {
    this.carregandoOperadores.set(true);
    this.usuarioService.buscarOperadoresPorGrupoECanal(canalId).subscribe({
      next: operadores => {
        this.operadores.set(operadores ?? []);
        if (this.operadorSelecionado?.id && !this.operadores().some(o => o.id === this.operadorSelecionado?.id)) {
          this.operadorSelecionado = null;
        }
      },
      complete: () => this.carregandoOperadores.set(false),
      error: () => this.carregandoOperadores.set(false)
    });
  }

  private buscarEtapas(fluxoId?: number): void {
    this.carregandoEtapas.set(true);
    const busca$ = fluxoId ? this.etapaService.buscar(fluxoId) : this.etapaService.buscarTodasEtapasSelect(true);
    busca$.subscribe({
      next: etapas => this.etapas.set(etapas ?? []),
      complete: () => this.carregandoEtapas.set(false),
      error: () => this.carregandoEtapas.set(false)
    });
  }

  transferir(): void {
    const sessao = this.sessaoAtual();
    if (!sessao?.id || !sessao.ativo) {
      this.msgService.msgAdvertencia('Sessão não se encontra mais ativa.');
      return;
    }
    if (this.canalSelecionado?.id && !this.operadorSelecionado?.id && this.operadores().length > 0) {
      this.msgService.msgAdvertencia('Selecione um operador.');
      return;
    }

    this.dialog.open(ModalConfirmacaoComponent, {
      data: { titulo: 'Transferir contato', texto: `Deseja transferir o atendimento de ${this.contato.nome ?? 'este contato'}?`, labelConfirmar: 'Transferir' }
    }).afterClosed().subscribe(confirmou => {
      if (confirmou) this.salvarTransferencia(sessao);
    });
  }

  private salvarTransferencia(sessao: SessaoBuscaContato): void {
    const payload: Sessao = {
      id: sessao.id,
      ativo: sessao.ativo,
      canal: this.canalSelecionado?.id ? { id: this.canalSelecionado.id } : undefined,
      operador: this.operadorSelecionado?.id ? { id: this.operadorSelecionado.id } as any : undefined,
      etapa: this.etapaSelecionada?.id ? { id: this.etapaSelecionada.id } as any : undefined,
    };

    this.transferindo.set(true);
    this.sessaoService.alterarSessao(payload).subscribe({
      next: () => {
        const destino = this.operadorSelecionado?.nome ?? this.canalSelecionado?.nome;
        this.msgService.msgSucesso(destino ? `Atendimento transferido para ${destino}.` : 'Atendimento transferido.');
        this.dialogRef.close({
          ...this.resultado,
          transferiu: true,
          canalTransferencia: this.canalSelecionado?.id ? { id: this.canalSelecionado.id, nome: this.canalSelecionado.nome } : undefined,
          operadorTransferencia: this.operadorSelecionado?.id ? { id: this.operadorSelecionado.id, nome: this.operadorSelecionado.nome } : undefined
        });
      },
      error: () => {
        this.transferindo.set(false);
        this.msgService.msgErro('Não foi possível transferir o contato.');
      }
    });
  }
}
